export class User {
    userId: string;
    userName: string;
    lastLogin: string;
    notificationMessages: Array<string>;
  }